import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * delete batch superbill
 */
export default async function deleteBatchSuperbill(batchStatementNo: string) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/batch_superbill/${batchStatementNo}`,
    {
      method: "DELETE",
    },
  );
  if (!res.ok) {
    const responseText = await res.text();
    throw new Error(getErrorDetail(responseText));
  }
}
